import { join } from 'juriquery'

import { Query } from '../types'

export const CONTRACTS_ROOT_ROUTE = '/contracts'
export const CONTRACT_ROUTE = ':docId'
export const CONTRACT_EDIT_ROUTE = ':docId/edit'

export const getContractsRoute = (query?: Query) =>
  join(CONTRACTS_ROOT_ROUTE, query)

const getRouteWithInjectedDocId = (route: string, id: number) =>
  route.replace(':docId', `${id}`)

export const getContractRoute = (contractId: number, query?: Query) =>
  join(
    `${getContractsRoute()}/${getRouteWithInjectedDocId(
      CONTRACT_ROUTE,
      contractId,
    )}`,
    query,
  )

export const getContractEditRoute = (contractId: number, query?: Query) =>
  join(
    `${getContractsRoute()}/${getRouteWithInjectedDocId(
      CONTRACT_EDIT_ROUTE,
      contractId,
    )}`,
    query,
  )
